import { apiClient, type PageData } from './client'
import type {
	Material,
	MaterialFolder,
	MaterialFolderPayload,
	MaterialListParams,
} from '@/types/material'

const buildSearch = (params: MaterialListParams) => {
	const search = new URLSearchParams()
	search.set('folder_id', String(params.folder_id ?? 0))
	if (params.keyword) search.set('keyword', params.keyword)
	if (params.uploader_id !== undefined) search.set('uploader_id', String(params.uploader_id))
	if (params.start_time) search.set('start_time', params.start_time)
	if (params.end_time) search.set('end_time', params.end_time)
	search.set('page', String(params.page ?? 1))
	search.set('page_size', String(params.page_size ?? 30))
	return search
}

export const materialsApi = {
	folderTree: async () => {
		const response = await apiClient.get<MaterialFolder[]>('/material-folders/tree')
		return response.data
	},

	createFolder: async (payload: MaterialFolderPayload) => {
		const response = await apiClient.post<MaterialFolder>('/material-folders', payload)
		return response.data
	},

	updateFolder: async (id: number, payload: MaterialFolderPayload) => {
		const response = await apiClient.put<MaterialFolder>(`/material-folders/${id}`, payload)
		return response.data
	},

	deleteFolder: async (id: number) => {
		await apiClient.delete(`/material-folders/${id}`)
	},

	list: async (params: MaterialListParams) => {
		const response = await apiClient.get<PageData<Material>>(`/materials?${buildSearch(params)}`)
		return response.data
	},

	delete: async (id: number) => {
		await apiClient.delete(`/materials/${id}`)
	},

	download: async (id: number) => {
		await apiClient.download(`/materials/${id}/download`, undefined, { method: 'GET' })
	},

	thumbnail: async (id: number) => {
		const blob = await apiClient.blob(`/materials/${id}/thumbnail`)
		return URL.createObjectURL(blob)
	},

	preview: async (id: number) => {
		const blob = await apiClient.blob(`/materials/${id}/preview`)
		return URL.createObjectURL(blob)
	},
}
